export default __webpack_public_path__ + "static/media/CodeQuest.f6c57763.png";